import { useWidget } from '../context/WidgetContext.js';

export type ConnectionBannerState =
  | 'offline'
  | 'connecting'
  | 'disconnected';

type ConnectionBannerProps = {
  state: ConnectionBannerState;
};

export function ConnectionBanner({ state }: ConnectionBannerProps) {
  const { t } = useWidget();

  const message =
    state === 'offline'
      ? t.connectionOffline
      : state === 'connecting'
        ? t.connectionReconnecting
        : t.connectionDisconnected;

  return (
    <div
      className={`teo-connection-banner teo-connection-banner--${state}`}
      role="status"
      aria-live="polite"
    >
      <span className="teo-connection-banner__dot" aria-hidden />
      <span>{message}</span>
    </div>
  );
}
